import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { useThemeContext } from '../../../../contexts/session/Theme.js';
import { useInteractiveListItem } from './useInteractiveListItem.js';

var _excluded = ["className", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InteractiveListItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var theme = useThemeContext();
  var _useInteractiveListIt = useInteractiveListItem(props, theme),
    className = _useInteractiveListIt.className,
    style = _useInteractiveListIt.style,
    rest = _objectWithoutProperties(_useInteractiveListIt, _excluded);
  return /*#__PURE__*/React.createElement('li', _objectSpread({
    role: props.role,
    'aria-disabled': props.disabled && 'true',
    tabIndex: props.disabled ? undefined : 0,
    ref: ref,
    className: className,
    style: style
  }, rest), props.children);
});

export { InteractiveListItem };
//# sourceMappingURL=InteractiveListItem.js.map
